import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GrantParentCompanyTenantAccessMutationVariables = Types.Exact<{
  input: Types.GrantParentCompanyTenantAccessInput;
}>;


export type GrantParentCompanyTenantAccessMutation = { __typename?: 'Mutation', grantParentCompanyTenantAccess: { __typename?: 'ParentCompanyAccessPayload', data?: Array<{ __typename?: 'MyParentCompanyMember', email: string, fullName: string, fusionAuthUserId?: string | null, status: Types.UserStatus, tenantId: string, userId: string }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RevokeParentCompanyTenantAccessMutationVariables = Types.Exact<{
  input: Types.RevokeParentCompanyTenantAccessInput;
}>;


export type RevokeParentCompanyTenantAccessMutation = { __typename?: 'Mutation', revokeParentCompanyTenantAccess: { __typename?: 'ParentCompanyAccessPayload', data?: Array<{ __typename?: 'MyParentCompanyMember', email: string, fullName: string, fusionAuthUserId?: string | null, status: Types.UserStatus, tenantId: string, userId: string }> | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const GrantParentCompanyTenantAccessDocument = new TypedDocumentString(`
    mutation GrantParentCompanyTenantAccess($input: GrantParentCompanyTenantAccessInput!) {
  grantParentCompanyTenantAccess(input: $input) {
    data {
      ...MyParentCompanyMemberRow
    }
    errors {
      code
      message
    }
  }
}
    fragment MyParentCompanyMemberRow on MyParentCompanyMember {
  email
  fullName
  fusionAuthUserId
  status
  tenantId
  userId
}`);
export const RevokeParentCompanyTenantAccessDocument = new TypedDocumentString(`
    mutation RevokeParentCompanyTenantAccess($input: RevokeParentCompanyTenantAccessInput!) {
  revokeParentCompanyTenantAccess(input: $input) {
    data {
      ...MyParentCompanyMemberRow
    }
    errors {
      code
      message
    }
  }
}
    fragment MyParentCompanyMemberRow on MyParentCompanyMember {
  email
  fullName
  fusionAuthUserId
  status
  tenantId
  userId
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GrantParentCompanyTenantAccess: build.mutation<GrantParentCompanyTenantAccessMutation, GrantParentCompanyTenantAccessMutationVariables>({
      query: (variables) => ({ document: GrantParentCompanyTenantAccessDocument, variables })
    }),
    RevokeParentCompanyTenantAccess: build.mutation<RevokeParentCompanyTenantAccessMutation, RevokeParentCompanyTenantAccessMutationVariables>({
      query: (variables) => ({ document: RevokeParentCompanyTenantAccessDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGrantParentCompanyTenantAccessMutation, useRevokeParentCompanyTenantAccessMutation } = injectedRtkApi;
